<mat-card-title id="header">
    Program Details
</mat-card-title>
<table mat-table [dataSource]="mappedDetails" class="program-details-table mat-elevation-z8">
    <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let detail" id="edit-icon-td" (click)="openDetailDialog(detail)">
            <mat-icon color="primary" fontIcon="edit"></mat-icon>
        </td>
    </ng-container>

    <ng-container matColumnDef="shortName">
        <th mat-header-cell *matHeaderCellDef> Short Name </th>
        <td mat-cell *matCellDef="let detail">
            {{ detail.shortName }}
        </td>
    </ng-container>

    <ng-container matColumnDef="longName">
        <th mat-header-cell *matHeaderCellDef> Long Name </th>
        <td mat-cell *matCellDef="let detail">
            {{ detail.longName }}
        </td>
    </ng-container>

    <ng-container matColumnDef="hours">
        <th mat-header-cell *matHeaderCellDef> Hours </th>
        <td mat-cell *matCellDef="let detail">
            {{ detail.hours }}
        </td>
    </ng-container>

    <ng-container matColumnDef="enableSurvey">
        <th mat-header-cell *matHeaderCellDef> Survey Enabled? </th>
        <td mat-cell *matCellDef="let detail">
            <div *ngIf="detail.enableSurvey">
                Yes
            </div>
            <div *ngIf="!detail.enableSurvey">
                No
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="surveyType">
        <th mat-header-cell *matHeaderCellDef> Survey Type </th>
        <td mat-cell *matCellDef="let detail">
            {{ detail.surveyType }}
        </td>
    </ng-container>

    <ng-container matColumnDef="surveyGroup">
        <th mat-header-cell *matHeaderCellDef> Survey Group </th>
        <td mat-cell *matCellDef="let detail">
            {{ detail.surveyGroup }}
        </td>
    </ng-container>

    <ng-container matColumnDef="surveyTrigger">
        <th mat-header-cell *matHeaderCellDef> Survey Trigger </th>
        <td mat-cell *matCellDef="let detail">
            {{ detail.surveyTrigger }}
        </td>
    </ng-container>

    <ng-container matColumnDef="surveyIdentifier">
        <th mat-header-cell *matHeaderCellDef> Survey Identifier </th>
        <td mat-cell *matCellDef="let detail">
            {{ detail.surveyIdentifier }}
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
